import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import styles from "./styles.module.scss";
import Input from "../../../custom/input/input";
import Details from "../../../custom/details/details";
import DownloadFile from "../../../custom/downloadFile/downloadFile";
import { useQuery } from "@tanstack/react-query";
import { getEducationalBackground } from "../../../requests";
import { userData } from "../../../state";
import { useAtomValue } from "jotai";
import { AxiosError } from "axios";
import { Spin } from "antd";
import { format } from "date-fns";

interface Qualification {
  [key: string]: string;
}

const qualificationDictionary: Qualification = {
  1: "SSCE / WAEC / NECO GCE & EQUIVALENT CERTIFICATE",
  2: "OND DEGREE",
  3: "BSC / HND DEGREE",
  4: "MSC / EQUIVALENT & HIGHER DEGREE",
};

const EducationalBackground = () => {
  const user = useAtomValue(userData);
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get-educational-background"],
    queryFn: () => getEducationalBackground(user?.MemberId!),
    enabled: !!user?.MemberId,
  });

  const qualications = data?.Data?.EducationModels;

  const documents = qualications?.map((model) => (
    <Details
      title={qualificationDictionary[model.QualificationId]}
      className={styles.details}
    >
      <section className={styles.field}>
        <Field
          as={Input}
          name="institutionNameSSCE"
          label="Name of Institution"
          placeholder={model?.InstitutionName}
          className={styles.input}
          disabled={true}
        />
      </section>
      <section className={styles.field}>
        <Field
          as={Input}
          name="disciplineSSCE"
          label="Discipline (Optional)"
          className={styles.input}
          placeholder={model?.Discipline}
          disabled={true}
        />
      </section>
      <section className={styles.field}>
        <Field
          as={Input}
          name="qualificationSSCE"
          label="Qualification"
          placeholder={model?.Qualification}
          className={styles.input}
          disabled={true}
        />
      </section>
      <section className={styles.field}>
        <Field
          as={Input}
          type="text"
          name="graduationDateSSCE"
          label="Graduation Date (MM/YY)"
          placeholder={format(new Date(model?.StartDate ?? null), "yyyy-MM-dd")}
          className={styles.input}
          disabled={true}
        />
      </section>

      <section className={styles.field}>
        <DownloadFile
          className={styles.input}
          title="Upload Certificate"
          documentName={`Certificate.${model?.CertificateUrl?.slice(-3)}`}
          documentUrl={model?.CertificateUrl}
          documentSize={10023}
        />
      </section>
    </Details>
  ));

  const formik = useFormik<FormikValues>({
    initialValues: {
      institutionNameSSCE: "",
      disciplineSSCE: "",
      qualificationSSCE: "",
      graduationDateSSCE: "",
      certificateSSCE: "",
      institutionNameBSC: "",
      disciplineBSC: "",
      qualificationBSC: "",
      graduationDateBSC: "",
      certificateBSC: "",
      institutionNameOND: "",
      disciplineOND: "",
      qualificationOND: "",
      graduationDateOND: "",
      certificateOND: "",
      institutionNameMSC: "",
      disciplineMSC: "",
      qualificationMSC: "",
      graduationDateMSC: "",
      certificateMSC: "",
    },
    onSubmit: () => {},
    enableReinitialize: true,
  });

  if (isLoading) {
    return <Spin />;
  }

  if (isError) {
    return <p className="error">{(error as AxiosError)?.message}</p>;
  }

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} className={styles.form}>
        {documents}
      </form>
    </FormikProvider>
  );
};

export default EducationalBackground;
